export default __webpack_public_path__ + "b6ee621383e0b4576c79317da0ae9b77.svg";